<template functional>
    <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        style="flex-shrink: 0"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.7071 7.29289C19.0976 7.68342 19.0976 8.31658 18.7071 8.70711L10.2071 17.2071C9.81658 17.5976 9.18342 17.5976 8.79289 17.2071L5.29289 13.7071C4.90237 13.3166 4.90237 12.6834 5.29289 12.2929C5.68342 11.9024 6.31658 11.9024 6.70711 12.2929L9.5 15.0858L17.2929 7.29289C17.6834 6.90237 18.3166 6.90237 18.7071 7.29289Z"
            fill="currentColor"
        ></path>
    </svg>
</template>
<script>
export default {
    name: 'CheckIcon',
    functional: true
};
</script>
